//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import {
    Table,    
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TableContainer,
    Typography,
} from '@mui/material';

//#endregion

//-----------------------------------------------------------------
export function PanelFileViewer(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
    },
    cell_name: {
      width: '20rem',
    },
    cell_shortcut: {
      width: '12rem',
    },
    cell_description: {

    }
  }

  const CELL_NAME = {
    sx : _styles.cell_name,
  };

  const CELL_SHORTCUT = {
    sx : _styles.cell_shortcut,
  };

  const CELL_DESCRIPTION = {
    sx : _styles.cell_description,
  };

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function render() {
    //-----------------------------------------------------------------
    return [
      renderFileViewerDocuments(),
      renderFileViewerImages()
    ]
  }

  //-----------------------------------------------------------------
  function renderFileViewerDocuments() {
    //-----------------------------------------------------------------
    return (
      <>
        <Typography variant="h6" sx={{mt:1, mb:1}}>Documents</Typography>
        <TableContainer component={Paper} >
          <Table>
            <TableBody>
              <TableRow>
                <TableCell {...CELL_NAME       }>Select a <strong>primary</strong> document</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Left-Click</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>Selects the primary document and displays its data in the corresponding panels (Fields, Images, etc.)</TableCell>
              </TableRow>
              <TableRow>
                <TableCell {...CELL_NAME       }>Select <strong>multiple primary</strong> documents</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + Left-Click</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>Allows for multiple documents to be displayed in the corresponding panels (Fields, Images, etc.)</TableCell>
              </TableRow>
              <TableRow>
                <TableCell {...CELL_NAME       }>Select a <strong>comparison</strong> document</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Shift + Left-Click</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>Selects the comparison document and displays its data in the corresponding panels (Fields, Images, etc.)</TableCell>
              </TableRow>
              <TableRow>
                <TableCell {...CELL_NAME       }>Select <strong>multiple comparison</strong> documents</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Shift + Ctrl + <div>Left-Click</div></strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>Allows for multiple documents to be displayed in the corresponding panels (Fields, Images, etc.)</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }

  //-----------------------------------------------------------------
  function renderFileViewerImages() {
    //-----------------------------------------------------------------
    return (
      <>
        <Typography variant="h6" sx={{mt:1, mb:1}}>Images</Typography>
        <TableContainer component={Paper} >
          <Table>
            <TableBody>
              <TableRow>
                <TableCell {...CELL_NAME       }>Move to the <strong>Previous primary</strong> image</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Page Up</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>The previous image in the primary document list will be selected and displayed</TableCell>
              </TableRow>
              <TableRow>
                <TableCell {...CELL_NAME       }>Move to the <strong>Next primary</strong> image</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Page Down</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>The next image in the primary document list will be selected and displayed</TableCell>
              </TableRow>
              <TableRow>
                <TableCell {...CELL_NAME       }>Move to the <strong>Previous comparison</strong> image</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Shift + Page Up</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>The previous image in the comparison document list will be selected and displayed</TableCell>
              </TableRow>
              <TableRow>
                <TableCell {...CELL_NAME       }>Move to the <strong>Next comparison</strong> image</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Shift + Page Down</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>The next image in the comparison document list will be selected and displayed</TableCell>
              </TableRow>
              {/*  */}
              <TableRow>
                <TableCell {...CELL_NAME       }><strong>Image Magnifier</strong></TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Left click</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>Displays a rectangular magnifier that zooms in on an image.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell {...CELL_NAME       }><strong>Highlight</strong> data</TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Right click</strong> + Drag</TableCell>
                <TableCell {...CELL_DESCRIPTION}>
                  Before drawing, be sure that the corresponding data entry field is selected in the left panel.
                  <br/>It is recommended to start at the <strong>top-left position</strong> of the text you want to highlight, then draw down horizontally to the <strong>bottom-right</strong>.
                  <br/> If your system configuration includes the ability to highlight multiple entries for a data extraction field, repeat this process as necessary.
                </TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell {...CELL_NAME       }><strong>Select a highlight</strong></TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + Left click</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}>Adds a border around the highlight to indicate its selection.<br/> Clicking again removes the selection.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell {...CELL_NAME       }><strong>Remove a highlight</strong></TableCell>
                <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + Right click</strong></TableCell>
                <TableCell {...CELL_DESCRIPTION}><strong>Highlight needs to be selected first.</strong> Removes the image highlight and coordinates from the field</TableCell>
              </TableRow> */}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }

  //#endregion

  return render();

}